module.exports = __webpack_public_path__ + "static/parade-2020-house05-dba805b5d8fbc5d8a545a21bd4a5e613.jpg";